var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFemale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.5C11.5 2.46875 9.03125 0 6 0C2.9375 0 0.5 2.46875 0.5 5.5C0.5 8.3125 2.5625 10.5938 5.25 10.9688V12.25H3.75C3.3125 12.25 3 12.5938 3 13C3 13.4375 3.3125 13.75 3.75 13.75H5.25V15.25C5.25 15.6875 5.5625 16 6 16C6.40625 16 6.75 15.6875 6.75 15.25V13.75H8.25C8.65625 13.75 9 13.4375 9 13C9 12.5938 8.65625 12.25 8.25 12.25H6.75V10.9688C9.40625 10.5938 11.5 8.28125 11.5 5.5ZM2 5.5C2 3.3125 3.78125 1.5 6 1.5C8.1875 1.5 10 3.3125 10 5.5C10 7.71875 8.1875 9.5 6 9.5C3.78125 9.5 2 7.71875 2 5.5Z",
    fill: "#6F7F93"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.4b476ebde0975227ed8163b4d16b8f2b.svg";
export { ForwardRef as ReactComponent };